import { css } from 'styled-components'

export const PointerWithOnClick = css`
  cursor: ${p => (p.onClick ? 'pointer' : 'initial')};
`
